import React from 'react';
import { PropTypes as PT } from 'prop-types';
import _compact from 'lodash/compact';
import classes from './Button.module.scss';

const Button = (props) => {
  const { className, id, kind, size } = props;
  const buttonClasses = _compact([classes[kind], size ? classes[size] : '', className]).join(' ');
  const buttonProps = {
    onClick: props.onClick,
    type: props.type,
    style: props.style,
    disabled: props.disabled
  };

  if (id) {
    buttonProps.id = id;
  }

  return (
    <button {...buttonProps} {...props.dataAttrs} className={buttonClasses}>
      {props.children}
    </button>
  );
};

Button.propTypes = {
  children: PT.oneOfType([PT.array, PT.element, PT.object, PT.string]),
  className: PT.string,
  dataAttrs: PT.object,
  disabled: PT.bool,
  id: PT.string,
  kind: PT.oneOf(['primary', 'secondary', 'tertiary', 'success', 'custom', 'text']),
  onClick: PT.func,
  size: PT.oneOf(['normal', 'small']),
  style: PT.object,
  type: PT.string
};

Button.defaultProps = {
  kind: 'primary',
  size: 'normal',
  type: 'button'
};

export default Button;
